import { render } from "./Roulette.vue?vue&type=template&id=2d6bde46"
import script from "./Roulette.vue?vue&type=script&lang=js"
export * from "./Roulette.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__